import gql from "graphql-tag";

const query = gql`
  query GraphicSet($graphicSetId: ID, $customerId: ID) {
    graphicset(graphicSetId: $graphicSetId, customerId: $customerId) {
      id
      name
      description
      customerId
      layouts {
        order
        sendTo
        seconds
        assetId
        pos {
          x
          y
        }
        size {
          x
          y
        }
        segments {
          type
          start
          end
        }
        asset {
          id
          codename
          path
          customerId
          format
          categories {
            name
          }
          sizePx {
            x
            y
          }
        }
      }
      schedules {
        type
        period
      }
    }
  }
`;

export default (graphicSetId, customerId) => ({
  query,
  skip: !graphicSetId || !customerId,
  variables: { graphicSetId, customerId },
});
